import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<Page::Boxes::Box::Versions::Version::Edit @registry={{@model.registry}} @box={{@model.box}} @version={{@model.version}} @providers={{@model.providers}} />", {
  moduleName: "vagrant/templates/registries/registry/boxes/box/versions/version/edit.hbs"
});